import {
  JobFunctions,
  fetchJobFunctions as apiFetchJobFunctions,
} from 'api/orgs';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

export type State = JobFunctions | null | undefined;

export type Action = {
  type: 'JOB_FUNCTIONS_SET';
  jobFunctions: JobFunctions | null | undefined;
};

// Reducer

export default function jobFunctionsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = null,
  action: Action
) {
  switch (action.type) {
    case 'JOB_FUNCTIONS_SET': {
      return action.jobFunctions;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

export const fetchJobFunctions =
  () => (dispatch: Dispatch, getState: GetState) => {
    if (getState().jobFunctions) {
      return;
    }

    apiFetchJobFunctions()
      .then((jobFunctions) => {
        dispatch({
          type: 'JOB_FUNCTIONS_SET',
          jobFunctions,
        });
      })
      .catch(setError);
  };
